/**
 * Нейтральная палитра интерфейса ERP — те же значения, что у токенов
 * `pages/_detailShared/detail.styled` (рамка поля, акцент, текст). Живёт в
 * `components/constants`, как и `tagTones`: молекулы и организмы не
 * импортируют страницы, а свои hex рядом заводить не должны.
 */
export const UI_COLORS = {
  /** Рамка полей, карточек и разделителей. */
  border: '#e2e8f0',
  /** Акцент: фокус, ссылки, наведение. */
  primary: '#2563eb',
  /** Основной текст. */
  text: '#0f172a',
  /** Подписи и второстепенные кнопки. */
  textSecondary: '#475569',
  /** Подсказки и счётчики. */
  textMuted: '#64748b',
  /** Плейсхолдер. */
  placeholder: '#94a3b8',
  /** Фон поля и карточки. */
  surface: '#fff',
  /** Приглушённый фон: превью, наведение. */
  surfaceSubtle: '#f8fafc',
} as const;

/**
 * ТЗ 0106 — знак ИИ-чата: синий → фиолетовый (те же значения, что у линий
 * колонок «Завтра» и «На этой неделе» доски задач, `taskTones`). Здесь, а не
 * на странице: кнопку чата рисует и шапка (organism), а она страницы не
 * импортирует.
 */
export const AI_ACCENT = {
  violet: '#7c3aed',
  gradient: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
} as const;
